import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Spinner from "../../../../components/Spinner";
import useAuthData from "../../../../hook/useAppData";
import { orderByName } from "../../../../libs/orderList";
import { getClients, uploadCsvAndXlsxClient } from "../../service";
import { BodyMiniCardList } from "./components/Body";
import { StatusMiniCardList } from "./components/Status";
import { IClient } from "./model";
import "./index.scss";
import { CardBox } from "../../../../components/Card";
import { toastError, toastSuccess } from "../../../../components/Toast";
import { CSVLink } from "react-csv";
import Button from "../../../../components/Button";
import { ModalPopUp } from "../../../../components/ModalPopUp";

export function ListClientPage() {
  const { token, corporation } = useAuthData();
  const [clients, setClients] = useState([]);
  const [needSpinner, setNeedSpinner] = useState(true);
  const [modalCsv, setModalCsv] = useState(false);
  const history = useHistory();

  useEffect(() => {
    clientsGet();
  }, []);

  useEffect(() => {
    if (!needSpinner) {
      setNeedSpinner(true);
    }
    setTimeout(() => {
      setNeedSpinner(false);
    }, 1000);
  }, [clients]);

  async function clientsGet() {
    const resultGet = await getClients(token);
    const resultGetOrder = await orderByName(resultGet, "name");
    setClients(resultGetOrder || resultGet);
  }

  function handleClickClient(id: string | number) {
    return history.push(`/client-project/${id}`);
  }

  return (
    <>
      <ModalPopUp status={modalCsv} onClickCancel={() => setModalCsv(false)}>
        <ModalCsvAndXlsxUpload token={token} getDataApi={clientsGet} setModalCsv={setModalCsv} />
      </ModalPopUp>
      <Spinner status={needSpinner}>
        <div className="client-list-page">
          <div className="client-list-page__header">
            <h1>
              Clientes {corporation} {clients?.length && "- " + clients?.length}
            </h1>
            <div className="flex items-start gap-6">
              <Button onClick={() => setModalCsv(true)} className="bg-blue-50 border border-primary text-primary h-16 flex-row flex mt-2">
                CSV
              </Button>
              <Link to="clients/form" className=" transition duration-300 hover:ease-in filter hover:brightness-90">
                {" "}
                Novo Cliente
              </Link>
            </div>
          </div>
          <div className="pt-12 gap-20 flex-wrap">
            {clients?.length
              ? clients?.map((client: IClient | null) => {
                  return (
                    <CardBox
                      name={client?.name}
                      img={client?.img}
                      key={client?.id}
                      onClick={() => handleClickClient(client?.id)}
                      classNameChildren="pl-4 pt-2"
                    >
                      <StatusMiniCardList client={client} />
                      <hr className="-ml-4" />
                      <BodyMiniCardList client={client} />
                    </CardBox>
                  );
                })
              : ""}
          </div>
        </div>
      </Spinner>
    </>
  );
}

const CSV_MODEL = `Cliente;CNPJ;Inscrição Estadual;Telefone;E-mail;Logradouro;Número;Complemento;Bairro;Cidade;Estado;Imagem
Cliente A;1010101010;20202020;3030303030;ClienteAemail@example.com;rua A;1;Esquina A;Bairro A;Cidade A;SP;http://placeimg.com/640/480/abstract
`;

function ModalCsvAndXlsxUpload({
  token,
  getDataApi,
  setModalCsv,
}: {
  token: string;
  getDataApi: () => void;
  setModalCsv: Dispatch<SetStateAction<boolean>>;
}) {
  const handleUploadFile = async (e: any) => {
    if (!e?.target?.files[0]) return;
    if (
      !e?.target?.files[0]?.type.includes(".csv") &&
      !e?.target?.files[0]?.type.includes(".xlsx") &&
      !e?.target?.files[0]?.type.includes("sheet") &&
      !e?.target?.files[0]?.type.includes("excel")
    ) {
      return toastError("Esse arquivo não é um CSV nem um xlsx!");
    }
    const isCsvOrXlsx = e?.target?.files[0]?.type.includes(".csv") || e?.target?.files[0]?.name?.includes(".csv");
    const res = await uploadCsvAndXlsxClient({ file: e.target.files[0], token, path: isCsvOrXlsx ? "csv" : "xlsx" });
    if (!res?.ok) return toastError("Erro ao enviar arquivo!");
    getDataApi();
    toastSuccess("Arquivo enviado com sucesso!");
    setTimeout(() => {
      setModalCsv(false);
    }, 2000);
  };

  return (
    <div className="w-full h-full flex flex-col justify-between mt-8">
      <div className="h-full flex-col justify-between m-2 w-full font-bold list-item">
        <h2 className="text-4xl mb-5">Instruções para fazer o upload do csv ou xlsx</h2>
        <ul className="text-2xl list-item">
          <li className="font-semibold my-9 mt-20">
            - A Imagem deve ser inserida apenas a url (link) da imagem, não deve ser inserido o nome da imagem ou o arquivo da mesma
          </li>
        </ul>
      </div>
      <div className="w-full m-2 flex-col flex items-end mr-8">
        <div className="h-full mb-8 w-full flex-row flex justify-around items-center">
          <div className="flex-col flex w-2/5">
            <p className="text-xl font-familyPoppins mt-8 mb-2 text-center">Suba o Arquivo .csv ou .xlsx aqui</p>
            <label className="bg-primary flex w-full input-type-file h-14 justify-center items-center rounded-lg text-1.4rem font-bold font-sourceSansPro cursor-pointer transition duration-300 hover:ease-in filter hover:brightness-90">
              Upload CSV
              <input
                type="file"
                onChange={(e) => {
                  handleUploadFile(e);
                }}
                accept=".csv,.xlsx"
              />
            </label>
          </div>
          <div className="flex flex-col w-2/5">
            <p className="text-xl font-familyPoppins mt-8 mb-2 text-center">Faça Download do modelo aqui</p>
            <CSVLink data={CSV_MODEL} filename={`modelo-cliente.csv`} target="_blank" className="text-primary">
              <Button className="bg-blue-100 border border-primary text-primary flex w-full">Baixar</Button>
            </CSVLink>
          </div>
        </div>
      </div>
    </div>
  );
}
